var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.5 15.7056C14.0839 15.7056 13.6758 15.6724 13.2781 15.6085C12.1349 18.0362 9.75306 19.7056 7 19.7056C5.80488 19.7056 4.6797 19.391 3.69545 18.8363L0.351333 20L1.24545 16.5405C0.460202 15.3521 0 13.9089 0 12.3528C0 8.29196 3.13401 5 7 5C7.2701 5 7.53663 5.01607 7.79877 5.04735C9.03325 2.64664 11.5705 1 14.5 1C18.6421 1 22 4.29196 22 8.35281C22 9.90892 21.5069 11.3521 20.6656 12.5405L21.6236 16L18.0406 14.8364C16.986 15.391 15.7805 15.7056 14.5 15.7056ZM7 8.35281C7 7.75037 7.0739 7.16485 7.2133 6.60449C7.14247 6.60151 7.07136 6.6 7 6.6C4.09089 6.6 1.6 9.10057 1.6 12.3528C1.6 13.5905 1.96535 14.7277 2.58033 15.6584L2.97258 16.252L2.64831 17.5066L3.85175 17.0879L4.48096 17.4424C5.23431 17.867 6.09006 18.1056 7 18.1056C8.98115 18.1056 10.7683 16.9459 11.7069 15.1788C8.94805 14.0928 7 11.4458 7 8.35281ZM12.5 8.5C12.5 9.05228 12.0523 9.5 11.5 9.5C10.9477 9.5 10.5 9.05228 10.5 8.5C10.5 7.94772 10.9477 7.5 11.5 7.5C12.0523 7.5 12.5 7.94772 12.5 8.5ZM15.5 8.5C15.5 9.05228 15.0523 9.5 14.5 9.5C13.9477 9.5 13.5 9.05228 13.5 8.5C13.5 7.94772 13.9477 7.5 14.5 7.5C15.0523 7.5 15.5 7.94772 15.5 8.5ZM18.5 8.5C18.5 9.05228 18.0523 9.5 17.5 9.5C16.9477 9.5 16.5 9.05228 16.5 8.5C16.5 7.94772 16.9477 7.5 17.5 7.5C18.0523 7.5 18.5 7.94772 18.5 8.5Z",
    fill: "#04B7EF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChat);
export default __webpack_public_path__ + "static/media/Chat.f03ac9ac014126fdd76e337500c09ace.svg";
export { ForwardRef as ReactComponent };